const laskutehtävät = {
	hajotelmat: {
		"3": [
			{ tehtävä: "? + 2 = 3",
			  oikea: 1,
			  väärät: [ 2,3,4,5 ],
			  suhde: 16 },
			{ tehtävä: "2 + ? = 3",
			  oikea: 1,
			  väärät: [ 2,3,4,5 ],
			  suhde: 17 },			  
			{ tehtävä: "1 + ? = 3",
			  oikea: 2,
			  väärät: [ 1,3,4,5 ],
			  suhde: 17 },
			{ tehtävä: "? + 1 = 3",
			  oikea: 2,
			  väärät: [ 1,3,4,5 ],
			  suhde: 16 },			  
			{ tehtävä: "2 + 1 = ?",
			  oikea: 3,
			  väärät: [ 1,2,4,5 ],
			  suhde: 17 },
			{ tehtävä: "1 + 2 = ?",
			  oikea: 3,
			  väärät: [ 1,2,4,5 ],
			  suhde: 17 },			  
		],
		"4": [
			{ tehtävä: "1 + ? = 4",
			  oikea: 3,
			  väärät: [ 1,2,4,5 ],
			  suhde: 15 },
  	  	    { tehtävä: "? + 1 = 4",
			  oikea: 3,
			  väärät: [ 1,2,4,5 ],
			  suhde: 15 },
  		    { tehtävä: "1 + 3 = ?",
			  oikea: 4,
			  väärät: [ 2,3,5,6 ],
			  suhde: 8 },
  		    { tehtävä: "3 + 1 = ?",
			  oikea: 4,
			  väärät: [ 2,3,5,6 ],
			  suhde: 8 },			  
  		    { tehtävä: "2 + ? = 4",
			  oikea: 2,
			  väärät: [ 1,3,4,5 ],
			  suhde: 8 },			  
  		    { tehtävä: "? + 2 = 4",
			  oikea: 2,
			  väärät: [ 1,3,4,5 ],
			  suhde: 8 },	
  		    { tehtävä: "2 + 2 = ?",
			  oikea: 4,
			  väärät: [ 2,3,5,6 ],
			  suhde: 8 },	
			{ tehtävä: "3 + ? = 4",
			  oikea: 1,
			  väärät: [ 2,3,4,5 ],
			  suhde: 15 },
			{ tehtävä: "? + 3 = 4",
			  oikea: 1,
			  väärät: [ 2,3,4,5 ],
			  suhde: 15 }
		],		
		"5": [
		  { tehtävä: "1 + ? = 5",
			  oikea: 4,
			  väärät: [ 1,2,3,5,6,7 ],
			  suhde: 7 },
			{ tehtävä: "? + 1 = 5",
			  oikea: 4,
			  väärät: [ 1,2,3,5,6,7 ],
			  suhde: 7 },  
			{ tehtävä: "2 + ? = 5",
			  oikea: 3,
			  väärät: [ 1,2,4,5,6,7 ],
			  suhde: 11 },
			{ tehtävä: "? + 2 = 5",
			  oikea: 3,
			  väärät: [ 1,2,4,5,6,7 ],
			  suhde: 11 },	
			{ tehtävä: "3 + ? = 5",
			  oikea: 2,
			  väärät: [ 1,3,4,5,6,7 ],
			  suhde: 11 },
			{ tehtävä: "? + 3 = 5",
			  oikea: 2,
			  väärät: [ 1,3,4,5,6,7 ],
			  suhde: 11 },			  
		  { tehtävä: "4 + ? = 5",
			  oikea: 1,
			  väärät: [ 2,3,4,5,6,7 ],
			  suhde: 7 },
			{ tehtävä: "? + 4 = 5",
			  oikea: 1,
			  väärät: [ 2,3,4,5,6,7 ],
			  suhde: 7 }, 
			{ tehtävä: "1 + 4 = ?",
			  oikea: 5,
			  väärät: [ 1,2,3,4,6,7 ],
			  suhde: 7 }, 
			{ tehtävä: "4 + 1 = ?",
			  oikea: 5,
			  väärät: [ 1,2,3,4,6,7 ],
			  suhde: 7 },	
			{ tehtävä: "2 + 3 = ?",
			  oikea: 5,
			  väärät: [ 1,2,3,4,6,7 ],
			  suhde: 7 },
			{ tehtävä: "3 + 2 = ?",
			  oikea: 5,
			  väärät: [ 1,2,3,4,6,7 ],
			  suhde: 7 },			  
		],
		"6": [
		  { tehtävä: "1 + ? = 6",
			  oikea: 5,
			  väärät: [ 2,3,4,6,7,8 ],
			  suhde: 4 },
		  { tehtävä: "? + 1 = 6",
			  oikea: 5,
			  väärät: [ 2,3,4,6,7,8 ],
			  suhde: 4 },			  
		  { tehtävä: "2 + ? = 6",
			  oikea: 4,
			  väärät: [ 2,3,5,6,7,8 ],
			  suhde: 4 },
		  { tehtävä: "? + 2 = 6",
			  oikea: 4,
			  väärät: [ 2,3,5,6,7,8 ],
			  suhde: 4 },
			{ tehtävä: "3 + ? = 6",
			  oikea: 3,
			  väärät: [ 1,2,4,5,6,7 ],
			  suhde: 4 },
			{ tehtävä: "? + 3 = 6",
			  oikea: 3,
			  väärät: [ 1,2,4,5,6,7 ],
			  suhde: 4 },
			{ tehtävä: "4 + ? = 6",
			  oikea: 2,
			  väärät: [ 1,3,4,5,6,7 ],
			  suhde: 5 },
			{ tehtävä: "? + 4 = 6",
			  oikea: 2,
			  väärät: [ 1,3,4,5,6,7 ],
			  suhde: 5 },
			{ tehtävä: "5 + ? = 6",
			  oikea: 1,
			  väärät: [ 2,3,4,5,6,7 ],
			  suhde: 4 },
			{ tehtävä: "? + 5 = 6",
			  oikea: 1,
			  väärät: [ 2,3,4,5,6,7 ],
			  suhde: 4 },
			{ tehtävä: "1 + 5 = ?",
			  oikea: 6,
			  väärät: [ 2,3,4,5,7,8 ],
			  suhde: 3 },
			{ tehtävä: "2 + 4 = ?",
			  oikea: 6,
			  väärät: [ 2,3,4,5,7,8 ],
			  suhde: 4 },
			{ tehtävä: "3 + 3 = ?",
			  oikea: 6,
			  väärät: [ 2,3,4,5,7,8 ],
			  suhde: 3 },
			{ tehtävä: "4 + 2 = ?",
			  oikea: 6,
			  väärät: [ 2,3,4,5,7,8 ],
			  suhde: 4 },
			{ tehtävä: "5 + 1 = ?",
			  oikea: 6,
			  väärät: [ 2,3,4,5,7,8 ],
			  suhde: 3 },
			{ tehtävä: "6 - 1 = ?",
			  oikea: 5,
			  väärät: [ 2,3,4,6,7 ],
			  suhde: 3 },					  
			{ tehtävä: "6 - 2 = ?",
			  oikea: 4,
			  väärät: [ 1,2,3,5,6,7 ],
			  suhde: 5 },
			{ tehtävä: "6 - 3 = ?",
			  oikea: 3,
			  väärät: [ 1,2,4,5,6,7 ],
			  suhde: 3 },
			{ tehtävä: "6 - 4 = ?",
			  oikea: 2,
			  väärät: [ 1,3,4,5,6,7 ],
			  suhde: 5 },				
			{ tehtävä: "6 - 5 = ?",
			  oikea: 1,
			  väärät: [ 2,3,4,5,6,7 ],
			  suhde: 3 },				
			{ tehtävä: "6 - ? = 5",
			  oikea: 1,
			  väärät: [ 2,3,4,5,6 ],
			  suhde: 4 },
			{ tehtävä: "6 - ? = 4",
			  oikea: 2,
			  väärät: [ 1,3,4,5,6 ],
			  suhde: 5 },
			{ tehtävä: "6 - ? = 3",
			  oikea: 3,
			  väärät: [ 1,2,4,5,6 ],
			  suhde: 4 },		
			{ tehtävä: "6 - ? = 2",
			  oikea: 4,
			  väärät: [ 1,2,3,5,6 ],
			  suhde: 5 },			
			{ tehtävä: "6 - ? = 1",
			  oikea: 5,
			  väärät: [ 1,2,3,4,6,7 ],
			  suhde: 4 },											
		],
    "7": [
		  { tehtävä: "1 + ? = 7",
			  oikea: 6,
			  väärät: [ 2,3,4,5,7,8 ],
			  suhde: 3 },
		  { tehtävä: "? + 1 = 7",
			  oikea: 6,
			  väärät: [ 2,3,4,5,7,8 ],
			  suhde: 3 },			  
		  { tehtävä: "2 + ? = 7",
			  oikea: 5,
			  väärät: [ 2,3,4,6,7,8 ],
			  suhde: 3 },
		  { tehtävä: "? + 2 = 7",
			  oikea: 5,
			  väärät: [ 2,3,4,6,7,8 ],
			  suhde: 4 },
		  { tehtävä: "3 + ? = 7",
			  oikea: 4,
			  väärät: [ 2,3,5,6,7,8 ],
			  suhde: 4 },
		  { tehtävä: "? + 3 = 7",
			  oikea: 4,
			  väärät: [ 2,3,5,6,7,8 ],
			  suhde: 4 },
		  { tehtävä: "4 + ? = 7",
			  oikea: 3,
			  väärät: [ 1,2,4,5,6,7 ],
			  suhde: 4 },
		  { tehtävä: "? + 4 = 7",
			  oikea: 3,
			  väärät: [ 1,2,4,5,6,7 ],
			  suhde: 4 },			
		  { tehtävä: "5 + ? = 7",
			  oikea: 2,
			  väärät: [ 1,3,4,5,6,7 ],
			  suhde: 3 },
		  { tehtävä: "? + 5 = 7",
			  oikea: 2,
			  väärät: [ 1,3,4,5,6,7 ],
			  suhde: 4 },
		  { tehtävä: "6 + ? = 7",
			  oikea: 1,
			  väärät: [ 2,3,4,5,6,7 ],
			  suhde: 3 },
		  { tehtävä: "? + 6 = 7",
			  oikea: 1,
			  väärät: [ 2,3,4,5,6,7 ],
			  suhde: 3 },			  
		  { tehtävä: "1 + 6 = ?",
			  oikea: 7,
			  väärät: [ 4,5,6,8,9 ],
			  suhde: 2 },
		  { tehtävä: "2 + 5 = ?",
			  oikea: 7,
			  väärät: [ 4,5,6,8,9 ],
			  suhde: 3 },
		  { tehtävä: "3 + 4 = ?",
			  oikea: 7,
			  väärät: [ 4,5,6,8,9 ],
			  suhde: 3 },
		  { tehtävä: "4 + 3 = ?",
			  oikea: 7,
			  väärät: [ 4,5,6,8,9 ],
			  suhde: 3 },
		  { tehtävä: "5 + 2 = ?",
			  oikea: 7,
			  väärät: [ 4,5,6,8,9 ],
			  suhde: 3 },			  
		  { tehtävä: "6 + 1 = ?",
			  oikea: 7,
			  väärät: [ 4,5,6,8,9 ],
			  suhde: 2 },
			{ tehtävä: "7 - 1 = ?",
			  oikea: 6,
			  väärät: [ 2,3,4,5,7,8 ],
			  suhde: 2 },
			{ tehtävä: "7 - 2 = ?",
			  oikea: 5,
			  väärät: [ 2,3,4,6,7,8 ],
			  suhde: 4 },			
			{ tehtävä: "7 - 3 = ?",
			  oikea: 4,
			  väärät: [ 2,3,5,6,7,8 ],
			  suhde: 4 },					
			{ tehtävä: "7 - 4 = ?",
			  oikea: 3,
			  väärät: [ 1,2,4,5,6,7 ],
			  suhde: 4 },				
			{ tehtävä: "7 - 5 = ?",
			  oikea: 2,
			  väärät: [ 1,3,4,5,6,7 ],
			  suhde: 4 },	
			{ tehtävä: "7 - 6 = ?",
			  oikea: 1,
			  väärät: [ 2,3,4,5,6,7 ],
			  suhde: 2 },		
			{ tehtävä: "7 - ? = 6",
			  oikea: 1,
			  väärät: [ 2,3,4,5,6,7 ],
			  suhde: 3 },
			{ tehtävä: "7 - ? = 5",
			  oikea: 2,
			  väärät: [ 1,3,4,5,6,7 ],
			  suhde: 4 },
			{ tehtävä: "7 - ? = 4",
			  oikea: 3,
			  väärät: [ 1,2,4,5,6,7 ],
			  suhde: 4 },		
			{ tehtävä: "7 - ? = 3",
			  oikea: 4,
			  väärät: [ 1,2,3,5,6,7 ],
			  suhde: 4 },			
			{ tehtävä: "7 - ? = 2",
			  oikea: 5,
			  väärät: [ 1,2,3,4,6,7 ],
			  suhde: 4 },				
			{ tehtävä: "7 - ? = 1",
			  oikea: 6,
			  väärät: [ 2,3,4,5,7,8 ],
			  suhde: 3 },											
		],
    "8": [
		  { tehtävä: "1 + ? = 8",
			  oikea: 7,
			  väärät: [ 3,4,5,6,8,9 ],
			  suhde: 2 },
		  { tehtävä: "? + 1 = 8",
			  oikea: 7,
			  väärät: [ 3,4,5,6,8,9 ],
			  suhde: 2 },
			{ tehtävä: "2 + ? = 8",
			  oikea: 6,
			  väärät: [ 3,4,5,7,8,9 ],
			  suhde: 3 },
		  { tehtävä: "? + 2 = 8",
			  oikea: 6,
			  väärät: [ 3,4,5,7,8,9 ],
			  suhde: 3 },
			{ tehtävä: "3 + ? = 8",
			  oikea: 5,
			  väärät: [ 3,4,6,7,8,9 ],
			  suhde: 4 },
		  { tehtävä: "? + 3 = 8",
			  oikea: 5,
			  väärät: [ 3,4,6,7,8,9 ],
			  suhde: 4 },
			{ tehtävä: "4 + ? = 8",
			  oikea: 4,
			  väärät: [ 2,3,5,6,7,8 ],
			  suhde: 2 },
		  { tehtävä: "? + 4 = 8",
			  oikea: 4,
			  väärät: [ 2,3,5,6,7,8 ],
			  suhde: 2 },			  
			{ tehtävä: "5 + ? = 8",
			  oikea: 3,
			  väärät: [ 1,2,4,5,6,7 ],
			  suhde: 4			  },
		  { tehtävä: "? + 5 = 8",
			  oikea: 3,
			  väärät: [ 1,2,4,5,6,7 ],
			  suhde: 4 },			  
			{ tehtävä: "6 + ? = 8",
			  oikea: 2,
			  väärät: [ 1,3,4,5,6,7 ],
			  suhde: 3 },
		  { tehtävä: "? + 6 = 8",
			  oikea: 2,
			  väärät: [ 1,3,4,5,6,7 ],
			  suhde: 3 },	
			{ tehtävä: "7 + ? = 8",
			  oikea: 1,
			  väärät: [ 2,3,4,5,6,7 ],
			  suhde: 2 },
		  { tehtävä: "? + 7 = 8",
			  oikea: 1,
			  väärät: [ 2,3,4,5,6,7 ],
			  suhde: 2 },	
		  { tehtävä: "1 + 7 = ?",
			  oikea: 8,
			  väärät: [ 4,5,6,7,9 ],
			  suhde: 2 },
		  { tehtävä: "2 + 6 = ?",
			  oikea: 8,
			  väärät: [ 4,5,6,7,9 ],
			  suhde: 3 },
		  { tehtävä: "3 + 5 = ?",
			  oikea: 8,
			  väärät: [ 4,5,6,7,9 ],
			  suhde: 4 },
		  { tehtävä: "4 + 4 = ?",
			  oikea: 8,
			  väärät: [ 4,5,6,7,9 ],
			  suhde: 2 },
		  { tehtävä: "5 + 3 = ?",
			  oikea: 8,
			  väärät: [ 4,5,6,7,9 ],
			  suhde: 4 },
		  { tehtävä: "6 + 2 = ?",
			  oikea: 8,
			  väärät: [ 4,5,6,7,9 ],
			  suhde: 3 },
		  { tehtävä: "7 + 1 = ?",
			  oikea: 8,
			  väärät: [ 4,5,6,7,9 ],
			  suhde: 2 },
		  { tehtävä: "8 - ? = 7",
			  oikea: 1,
			  väärät: [ 2,3,4,5,6 ],
			  suhde: 2 },			  
		  { tehtävä: "8 - ? = 6",
			  oikea: 2,
			  väärät: [ 1,3,4,5,6 ],
			  suhde: 3 },
			{ tehtävä: "8 - ? = 5",
			  oikea: 3,
			  väärät: [ 1,2,4,5,6 ],
			  suhde: 4 },
		  { tehtävä: "8 - ? = 4",
			  oikea: 4,
			  väärät: [ 1,2,3,5,6,7 ],
			  suhde: 2 },			
		  { tehtävä: "8 - ? = 3",
			  oikea: 5,
			  väärät: [ 2,3,4,6,7 ],
			  suhde: 4 },		
		  { tehtävä: "8 - ? = 2",
			  oikea: 6,
			  väärät: [ 3,4,5,7,8 ],
			  suhde: 3 },			
		  { tehtävä: "8 - ? = 1",
			  oikea: 7,
			  väärät: [ 3,4,5,6,8,9 ],
			  suhde: 2 },
		  { tehtävä: "8 - 1 = ?",
			  oikea: 7,
			  väärät: [ 3,4,5,6,8,9 ],
			  suhde: 2 },			  
          { tehtävä: "8 - 2 = ?",
			  oikea: 6,
			  väärät: [ 3,4,5,7,8 ],
			  suhde: 3 },		
          { tehtävä: "8 - 3 = ?",
			  oikea: 5,
			  väärät: [ 2,3,4,6,7 ],
			  suhde: 4 },			  
          { tehtävä: "8 - 4 = ?",
			  oikea: 4,
			  väärät: [ 1,2,3,5,6,7 ],
			  suhde: 2 },			
          { tehtävä: "8 - 5 = ?",
			  oikea: 3,
			  väärät: [ 1,2,4,5,6 ],
			  suhde: 4 },			  
          { tehtävä: "8 - 6 = ?",
			  oikea: 2,
			  väärät: [ 1,3,4,5,6 ],
			  suhde: 3 },			  
          { tehtävä: "8 - 7 = ?",
			  oikea: 1,
			  väärät: [ 2,3,4,5,6 ],
			  suhde: 2 },			  
		],	
	"9": [
		  { tehtävä: "1 + ? = 9",
			  oikea: 8,
			  väärät: [ 3,4,5,6,7,9 ],
			  suhde: 2 },	
		  { tehtävä: "? + 1 = 9",
			  oikea: 8,
			  väärät: [ 3,4,5,6,7,9 ],
			  suhde: 2 },
		  { tehtävä: "2 + ? = 9",
			  oikea: 7,
			  väärät: [ 3,4,5,6,8,9 ],
			  suhde: 2 },	
		  { tehtävä: "? + 2 = 9",
			  oikea: 7,
			  väärät: [ 3,4,5,6,8,9 ],
			  suhde: 2 },
		  { tehtävä: "3 + ? = 9",
			  oikea: 6,
			  väärät: [ 3,4,5,7,8,9 ],
			  suhde: 2 },	
		  { tehtävä: "? + 3 = 9",
			  oikea: 6,
			  väärät: [ 3,4,5,7,8,9 ],
			  suhde: 2 },		
		  { tehtävä: "4 + ? = 9",
			  oikea: 5,
			  väärät: [ 3,4,6,7,8,9 ],
			  suhde: 2 },	
		  { tehtävä: "? + 4 = 9",
			  oikea: 5,
			  väärät: [ 3,4,6,7,8,9 ],
			  suhde: 3 },		
		  { tehtävä: "5 + ? = 9",
			  oikea: 4,
			  väärät: [ 2,3,5,6,7,8 ],
			  suhde: 2 },	
		  { tehtävä: "? + 5 = 9",
			  oikea: 4,
			  väärät: [ 2,3,5,6,7,8 ],
			  suhde: 3 },			
		  { tehtävä: "6 + ? = 9",
			  oikea: 3,
			  väärät: [ 1,2,4,5,6,7 ],
			  suhde: 3 },	
		  { tehtävä: "? + 6 = 9",
			  oikea: 3,
			  väärät: [ 1,2,4,5,6,7 ],
			  suhde: 2 },			
		  { tehtävä: "7 + ? = 9",
			  oikea: 2,
			  väärät: [ 1,3,4,5,6,7 ],
			  suhde: 3 },	
		  { tehtävä: "? + 7 = 9",
			  oikea: 2,
			  väärät: [ 1,3,4,5,6,7 ],
			  suhde: 2 },			
		  { tehtävä: "8 + ? = 9",
			  oikea: 1,
			  väärät: [ 2,3,4,5,6,7 ],
			  suhde: 2 },	
		  { tehtävä: "? + 8 = 9",
			  oikea: 1,
			  väärät: [ 2,3,4,5,6,7 ],
			  suhde: 2 },	
		  { tehtävä: "1 + 8 = ?",
			  oikea: 9,
			  väärät: [ 4,5,6,7,8 ],
			  suhde: 2 },			  		        	  	  	  
		  { tehtävä: "2 + 7 = ?",
			  oikea: 9,
			  väärät: [ 4,5,6,7,8 ],
			  suhde: 2 },	
		  { tehtävä: "3 + 6 = ?",
			  oikea: 9,
			  väärät: [ 4,5,6,7,8 ],
			  suhde: 2 },	
		  { tehtävä: "4 + 5 = ?",
			  oikea: 9,
			  väärät: [ 4,5,6,7,8 ],
			  suhde: 2 },	
		  { tehtävä: "5 + 4 = ?",
			  oikea: 9,
			  väärät: [ 4,5,6,7,8 ],
			  suhde: 2 },	
		  { tehtävä: "6 + 3 = ?",
			  oikea: 9,
			  väärät: [ 4,5,6,7,8 ],
			  suhde: 2 },	
		  { tehtävä: "7 + 2 = ?",
			  oikea: 9,
			  väärät: [ 4,5,6,7,8 ],
			  suhde: 2 },	
		  { tehtävä: "8 + 1 = ?",
			  oikea: 9,
			  väärät: [ 4,5,6,7,8 ],
			  suhde: 2 },		
		  { tehtävä: "9 - ? = 8",
			  oikea: 1,
			  väärät: [ 2,3,4,5,6 ],
			  suhde: 3 },
		  { tehtävä: "9 - ? = 7",
			  oikea: 2,
			  väärät: [ 1,3,4,5,6 ],
			  suhde: 3 },
		  { tehtävä: "9 - ? = 6",
			  oikea: 3,
			  väärät: [ 1,2,4,5,6 ],
			  suhde: 3 },
		  { tehtävä: "9 - ? = 5",
			  oikea: 4,
			  väärät: [ 1,2,3,5,6 ],
			  suhde: 3 },
		  { tehtävä: "9 - ? = 4",
			  oikea: 5,
			  väärät: [ 3,4,6,7,8 ],
			  suhde: 3 },
		  { tehtävä: "9 - ? = 3",
			  oikea: 6,
			  väärät: [ 3,4,5,7,8 ],
			  suhde: 3 },	
		  { tehtävä: "9 - ? = 2",
			  oikea: 7,
			  väärät: [ 3,4,5,6,8 ],
			  suhde: 3 },			
		  { tehtävä: "9 - ? = 1",
			  oikea: 8,
			  väärät: [ 3,4,5,6,7 ],
			  suhde: 3 },
		  { tehtävä: "9 - 1 = ?",
			  oikea: 8,
			  väärät: [ 3,4,5,6,7,9 ],
			  suhde: 3 },
		  { tehtävä: "9 - 2 = ?",
			  oikea: 7,
			  väärät: [ 3,4,5,6,8,9 ],
			  suhde: 3 },
		  { tehtävä: "9 - 3 = ?",
			  oikea: 6,
			  väärät: [ 3,4,5,7,8,9 ],
			  suhde: 3 },
		  { tehtävä: "9 - 4 = ?",
			  oikea: 5,
			  väärät: [ 2,3,4,6,7,8 ],
			  suhde: 3 },
		  { tehtävä: "9 - 5 = ?",
			  oikea: 4,
			  väärät: [ 2,3,5,6,7,8 ],
			  suhde: 3 },
		  { tehtävä: "9 - 6 = ?",
			  oikea: 3,
			  väärät: [ 1,2,4,5,6,7 ],
			  suhde: 3 },
		  { tehtävä: "9 - 7 = ?",
			  oikea: 2,
			  väärät: [ 1,3,4,5,6,7 ],
			  suhde: 3 },
		  { tehtävä: "9 - 8 = ?",
			  oikea: 1,
			  väärät: [ 2,3,4,5,6,7 ],
			  suhde: 3 },
	  ],				  
	"10": [
		  { tehtävä: "1 + ? = 10",
			  oikea: 9,
			  väärät: [ 3,4,5,6,7,8 ],
			  suhde: 2 },	
		  { tehtävä: "? + 1 = 10",
			  oikea: 9,
			  väärät: [ 3,4,5,6,7,8 ],
			  suhde: 2 },
		  { tehtävä: "2 + ? = 10",
			  oikea: 8,
			  väärät: [ 3,4,5,6,7,9 ],
			  suhde: 2 },	
		  { tehtävä: "? + 2 = 10",
			  oikea: 8,
			  väärät: [ 3,4,5,6,7,9 ],
			  suhde: 2 },
		  { tehtävä: "3 + ? = 10",
			  oikea: 7,
			  väärät: [ 3,4,5,6,8,9 ],
			  suhde: 2 },	
		  { tehtävä: "? + 3 = 10",
			  oikea: 7,
			  väärät: [ 3,4,5,6,8,9 ],
			  suhde: 2 },		
		  { tehtävä: "4 + ? = 10",
			  oikea: 6,
			  väärät: [ 3,4,5,7,8,9 ],
			  suhde: 2 },	
		  { tehtävä: "? + 4 = 10",
			  oikea: 6,
			  väärät: [ 3,4,5,7,8,9 ],
			  suhde: 3 },		
		  { tehtävä: "5 + ? = 10",
			  oikea: 5,
			  väärät: [ 2,3,4,6,7,8 ],
			  suhde: 2 },	
		  { tehtävä: "? + 5 = 10",
			  oikea: 5,
			  väärät: [ 2,3,4,6,7,8 ],
			  suhde: 3 },			
		  { tehtävä: "6 + ? = 10",
			  oikea: 4,
			  väärät: [ 1,2,3,5,6,7 ],
			  suhde: 3 },	
		  { tehtävä: "? + 6 = 10",
			  oikea: 4,
			  väärät: [ 1,2,3,5,6,7 ],
			  suhde: 2 },			
		  { tehtävä: "7 + ? = 10",
			  oikea: 3,
			  väärät: [ 1,2,4,5,6,7 ],
			  suhde: 3 },	
		  { tehtävä: "? + 7 = 10",
			  oikea: 3,
			  väärät: [ 1,2,4,5,6,7 ],
			  suhde: 2 },			
		  { tehtävä: "8 + ? = 10",
			  oikea: 2,
			  väärät: [ 1,3,4,5,6,7 ],
			  suhde: 2 },	
		  { tehtävä: "? + 8 = 10",
			  oikea: 2,
			  väärät: [ 1,3,4,5,6,7 ],
			  suhde: 2 },	
		  { tehtävä: "9 + ? = 10",
			  oikea: 1,
			  väärät: [ 2,3,4,5,6,7 ],
			  suhde: 1 },	
		  { tehtävä: "? + 9 = 10",
			  oikea: 1,
			  väärät: [ 2,3,4,5,6,7 ],
			  suhde: 1 },	
		  { tehtävä: "1 + 9 = ?",
			  oikea: 10,
			  väärät: [ 5,6,7,8,9 ],
			  suhde: 2 },			  		        	  	  	  
		  { tehtävä: "2 + 8 = ?",
			  oikea: 10,
			  väärät: [ 5,6,7,8,9 ],
			  suhde: 2 },	
		  { tehtävä: "3 + 7 = ?",
			  oikea: 10,
			  väärät: [ 5,6,7,8,9 ],
			  suhde: 2 },	
		  { tehtävä: "4 + 6 = ?",
			  oikea: 10,
			  väärät: [ 5,6,7,8,9 ],
			  suhde: 2 },	
		  { tehtävä: "5 + 5 = ?",
			  oikea: 10,
			  väärät: [ 5,6,7,8,9 ],
			  suhde: 2 },	
		  { tehtävä: "6 + 4 = ?",
			  oikea: 10,
			  väärät: [ 5,6,7,8,9 ],
			  suhde: 2 },	
		  { tehtävä: "7 + 3 = ?",
			  oikea: 10,
			  väärät: [ 5,6,7,8,9 ],
			  suhde: 2 },	
		  { tehtävä: "8 + 2 = ?",
			  oikea: 10,
			  väärät: [ 5,6,7,8,9 ],
			  suhde: 2 },		
		  { tehtävä: "9 + 1 = ?",
			  oikea: 10,
			  väärät: [ 5,6,7,8,9 ],
			  suhde: 1 },			  
		  { tehtävä: "10 - ? = 9",
			  oikea: 1,
			  väärät: [ 2,3,4,5,6 ],
			  suhde: 3 },
		  { tehtävä: "10 - ? = 8",
			  oikea: 2,
			  väärät: [ 1,3,4,5,6 ],
			  suhde: 3 },
		  { tehtävä: "10 - ? = 7",
			  oikea: 3,
			  väärät: [ 1,2,4,5,6 ],
			  suhde: 3 },
		  { tehtävä: "10 - ? = 6",
			  oikea: 4,
			  väärät: [ 1,2,3,5,6 ],
			  suhde: 3 },
		  { tehtävä: "10 - ? = 5",
			  oikea: 5,
			  väärät: [ 3,4,6,7,8 ],
			  suhde: 3 },
		  { tehtävä: "10 - ? = 4",
			  oikea: 6,
			  väärät: [ 3,4,5,7,8 ],
			  suhde: 3 },	
		  { tehtävä: "10 - ? = 3",
			  oikea: 7,
			  väärät: [ 3,4,5,6,8 ],
			  suhde: 3 },			
		  { tehtävä: "10 - ? = 2",
			  oikea: 8,
			  väärät: [ 3,4,5,6,7 ],
			  suhde: 3 },
		  { tehtävä: "10 - ? = 1",
			  oikea: 9,
			  väärät: [ 4,5,6,7,8 ],
			  suhde: 1 },			  
		  { tehtävä: "10 - 1 = ?",
			  oikea: 9,
			  väärät: [ 3,4,5,6,7,8 ],
			  suhde: 3 },
		  { tehtävä: "10 - 2 = ?",
			  oikea: 8,
			  väärät: [ 3,4,5,6,7,9 ],
			  suhde: 3 },
		  { tehtävä: "10 - 3 = ?",
			  oikea: 7,
			  väärät: [ 3,4,5,6,8,9 ],
			  suhde: 3 },
		  { tehtävä: "10 - 4 = ?",
			  oikea: 6,
			  väärät: [ 2,3,4,5,7,8 ],
			  suhde: 2 },
		  { tehtävä: "10 - 5 = ?",
			  oikea: 5,
			  väärät: [ 2,3,4,6,7,8 ],
			  suhde: 2 },
		  { tehtävä: "10 - 6 = ?",
			  oikea: 4,
			  väärät: [ 1,2,3,5,6,7 ],
			  suhde: 2 },
		  { tehtävä: "10 - 7 = ?",
			  oikea: 3,
			  väärät: [ 1,2,4,5,6,7 ],
			  suhde: 2 },
		  { tehtävä: "10 - 8 = ?",
			  oikea: 2,
			  väärät: [ 1,3,4,5,6,7 ],
			  suhde: 2 },
		  { tehtävä: "10 - 9 = ?",
			  oikea: 1,
			  väärät: [ 2,3,4,5,6,7 ],
			  suhde: 1 },			  
	  ],
	  "3-10-": [
			{ tehtävä: "3 - 1 = ?",
			  oikea: 2,
			  väärät: [ 0,1,3,4 ],
			  suhde: 1 },
			{ tehtävä: "3 - 2 = ?",
			  oikea: 1,
			  väärät: [ 0,2,3,4 ],
			  suhde: 2 },			  
			{ tehtävä: "4 - 1 = ?",
			  oikea: 3,
			  väärät: [ 0,1,2,4 ],
			  suhde: 1 },
  		    { tehtävä: "4 - 2 = ?",
			  oikea: 2,
			  väärät: [ 0,1,3,4 ],
			  suhde: 2 },
			{ tehtävä: "4 - 3 = ?",
			  oikea: 1,
			  väärät: [ 0,2,3,4 ],
			  suhde: 3 },
		    { tehtävä: "5 - 1 = ?",
			  oikea: 4,
			  väärät: [ 1,2,3,5,6 ],
			  suhde: 1 },
			{ tehtävä: "5 - 2 = ?",
			  oikea: 3,
			  väärät: [ 1,2,4,5,6,7 ],
			  suhde: 2 },
			{ tehtävä: "5 - 3 = ?",
			  oikea: 2,
			  väärät: [ 1,3,4,5,6,8 ],
			  suhde: 3 },
		    { tehtävä: "5 - 4 = ?",
			  oikea: 1,
			  väärät: [ 2,3,4,5,6,9 ],
			  suhde: 2 },
			{ tehtävä: "6 - 1 = ?",
			  oikea: 5,
			  väärät: [ 2,3,4,6,7 ],
			  suhde: 1 },					  
			{ tehtävä: "6 - 2 = ?",
			  oikea: 4,
			  väärät: [ 1,2,3,5,6,7 ],
			  suhde: 3 },
			{ tehtävä: "6 - 3 = ?",
			  oikea: 3,
			  väärät: [ 1,2,4,5,6,7 ],
			  suhde: 3 },
			{ tehtävä: "6 - 4 = ?",
			  oikea: 2,
			  väärät: [ 1,3,4,5,6,7 ],
			  suhde: 3 },				
			{ tehtävä: "6 - 5 = ?",
			  oikea: 1,
			  väärät: [ 2,3,4,5,6,7 ],
			  suhde: 2 },				
			{ tehtävä: "7 - 1 = ?",
			  oikea: 6,
			  väärät: [ 2,3,4,5,7,8 ],
			  suhde: 1 },
			{ tehtävä: "7 - 2 = ?",
			  oikea: 5,
			  väärät: [ 2,3,4,6,7,8 ],
			  suhde: 2 },			
			{ tehtävä: "7 - 3 = ?",
			  oikea: 4,
			  väärät: [ 2,3,5,6,7,8 ],
			  suhde: 3 },					
			{ tehtävä: "7 - 4 = ?",
			  oikea: 3,
			  väärät: [ 1,2,4,5,6,7 ],
			  suhde: 3 },				
			{ tehtävä: "7 - 5 = ?",
			  oikea: 2,
			  väärät: [ 1,3,4,5,6,7 ],
			  suhde: 3 },	
			{ tehtävä: "7 - 6 = ?",
			  oikea: 1,
			  väärät: [ 2,3,4,5,6,7 ],
			  suhde: 2 },		
 		    { tehtävä: "8 - 1 = ?",
			  oikea: 7,
			  väärät: [ 3,4,5,6,8,9 ],
			  suhde: 1 },			  
            { tehtävä: "8 - 2 = ?",
			  oikea: 6,
			  väärät: [ 3,4,5,7,8 ],
			  suhde: 2 },		
            { tehtävä: "8 - 3 = ?",
			  oikea: 5,
			  väärät: [ 2,3,4,6,7 ],
			  suhde: 3 },			  
            { tehtävä: "8 - 4 = ?",
			  oikea: 4,
			  väärät: [ 1,2,3,5,6,7 ],
			  suhde: 3 },			
            { tehtävä: "8 - 5 = ?",
			  oikea: 3,
			  väärät: [ 1,2,4,5,6 ],
			  suhde: 3 },			  
            { tehtävä: "8 - 6 = ?",
			  oikea: 2,
			  väärät: [ 1,3,4,5,6 ],
			  suhde: 3 },			  
            { tehtävä: "8 - 7 = ?",
			  oikea: 1,
			  väärät: [ 2,3,4,5,6 ],
			  suhde: 2 },			  
		    { tehtävä: "9 - 1 = ?",
			  oikea: 8,
			  väärät: [ 3,4,5,6,7,9 ],
			  suhde: 1 },
		    { tehtävä: "9 - 2 = ?",
			  oikea: 7,
			  väärät: [ 3,4,5,6,8,9 ],
			  suhde: 2 },
		    { tehtävä: "9 - 3 = ?",
			  oikea: 6,
			  väärät: [ 3,4,5,7,8,9 ],
			  suhde: 3 },
		    { tehtävä: "9 - 4 = ?",
			  oikea: 5,
			  väärät: [ 2,3,4,6,7,8 ],
			  suhde: 3 },
		    { tehtävä: "9 - 5 = ?",
			  oikea: 4,
			  väärät: [ 2,3,5,6,7,8 ],
			  suhde: 3 },
		    { tehtävä: "9 - 6 = ?",
			  oikea: 3,
			  väärät: [ 1,2,4,5,6,7 ],
			  suhde: 3 },
		    { tehtävä: "9 - 7 = ?",
			  oikea: 2,
			  väärät: [ 1,3,4,5,6,7 ],
			  suhde: 3 },
		    { tehtävä: "9 - 8 = ?",
			  oikea: 1,
			  väärät: [ 2,3,4,5,6,7 ],
			  suhde: 2 },
		    { tehtävä: "10 - 1 = ?",
			  oikea: 9,
			  väärät: [ 3,4,5,6,7,8 ],
			  suhde: 1 },
		    { tehtävä: "10 - 2 = ?",
			  oikea: 8,
			  väärät: [ 3,4,5,6,7,9 ],
			  suhde: 2 },
		    { tehtävä: "10 - 3 = ?",
			  oikea: 7,
			  väärät: [ 3,4,5,6,8,9 ],
			  suhde: 2 },
		    { tehtävä: "10 - 4 = ?",
			  oikea: 6,
			  väärät: [ 2,3,4,5,7,8 ],
			  suhde: 3 },
		    { tehtävä: "10 - 5 = ?",
			  oikea: 5,
			  väärät: [ 2,3,4,6,7,8 ],
			  suhde: 2 },
		    { tehtävä: "10 - 6 = ?",
			  oikea: 4,
			  väärät: [ 1,2,3,5,6,7 ],
			  suhde: 3 },
		    { tehtävä: "10 - 7 = ?",
			  oikea: 3,
			  väärät: [ 1,2,4,5,6,7 ],
			  suhde: 3 },
		    { tehtävä: "10 - 8 = ?",
			  oikea: 2,
			  väärät: [ 1,3,4,5,6,7 ],
			  suhde: 2 },
		    { tehtävä: "10 - 9 = ?",
			  oikea: 1,
			  väärät: [ 2,3,4,5,6,7 ],
			  suhde: 2 },			  
	  ],
	  "3-10+": [
			{ tehtävä: "2 + 1 = ?",
			  oikea: 3,
			  väärät: [ 1,2,4,5 ],
			  suhde: 2 },
			{ tehtävä: "1 + 2 = ?",
			  oikea: 3,
			  väärät: [ 1,2,4,5 ],
			  suhde: 2 },			  
  		    { tehtävä: "1 + 3 = ?",
			  oikea: 4,
			  väärät: [ 2,3,5,6 ],
			  suhde: 2 },
  		    { tehtävä: "3 + 1 = ?",
			  oikea: 4,
			  väärät: [ 2,3,5,6 ],
			  suhde: 2 },			  
  		    { tehtävä: "2 + 2 = ?",
			  oikea: 4,
			  väärät: [ 2,3,5,6 ],
			  suhde: 2 },	
			{ tehtävä: "1 + 4 = ?",
			  oikea: 5,
			  väärät: [ 1,2,3,4,6,7 ],
			  suhde: 2 }, 
			{ tehtävä: "4 + 1 = ?",
			  oikea: 5,
			  väärät: [ 1,2,3,4,6,7 ],
			  suhde: 2 },	
			{ tehtävä: "2 + 3 = ?",
			  oikea: 5,
			  väärät: [ 1,2,3,4,6,7 ],
			  suhde: 2 },
			{ tehtävä: "3 + 2 = ?",
			  oikea: 5,
			  väärät: [ 1,2,3,4,6,7 ],
			  suhde: 2 },			  
			{ tehtävä: "1 + 5 = ?",
			  oikea: 6,
			  väärät: [ 2,3,4,5,7,8 ],
			  suhde: 2 },
			{ tehtävä: "2 + 4 = ?",
			  oikea: 6,
			  väärät: [ 2,3,4,5,7,8 ],
			  suhde: 2 },
			{ tehtävä: "3 + 3 = ?",
			  oikea: 6,
			  väärät: [ 2,3,4,5,7,8 ],
			  suhde: 2 },
			{ tehtävä: "4 + 2 = ?",
			  oikea: 6,
			  väärät: [ 2,3,4,5,7,8 ],
			  suhde: 2 },
			{ tehtävä: "5 + 1 = ?",
			  oikea: 6,
			  väärät: [ 2,3,4,5,7,8 ],
			  suhde: 2 },
		    { tehtävä: "1 + 6 = ?",
			  oikea: 7,
			  väärät: [ 4,5,6,8,9 ],
			  suhde: 2 },
		    { tehtävä: "2 + 5 = ?",
			  oikea: 7,
			  väärät: [ 4,5,6,8,9 ],
			  suhde: 2 },
		    { tehtävä: "3 + 4 = ?",
			  oikea: 7,
			  väärät: [ 4,5,6,8,9 ],
			  suhde: 3 },
		    { tehtävä: "4 + 3 = ?",
			  oikea: 7,
			  väärät: [ 4,5,6,8,9 ],
			  suhde: 3 },
		    { tehtävä: "5 + 2 = ?",
			  oikea: 7,
			  väärät: [ 4,5,6,8,9 ],
			  suhde: 3 },			  
		    { tehtävä: "6 + 1 = ?",
			  oikea: 7,
			  väärät: [ 4,5,6,8,9 ],
			  suhde: 2 },
		    { tehtävä: "1 + 7 = ?",
			  oikea: 8,
			  väärät: [ 4,5,6,7,9 ],
			  suhde: 2 },
		    { tehtävä: "2 + 6 = ?",
			  oikea: 8,
			  väärät: [ 4,5,6,7,9 ],
			  suhde: 2 },
		    { tehtävä: "3 + 5 = ?",
			  oikea: 8,
			  väärät: [ 4,5,6,7,9 ],
			  suhde: 3 },
		    { tehtävä: "4 + 4 = ?",
			  oikea: 8,
			  väärät: [ 4,5,6,7,9 ],
			  suhde: 3 },
		    { tehtävä: "5 + 3 = ?",
			  oikea: 8,
			  väärät: [ 4,5,6,7,9 ],
			  suhde: 3 },
		    { tehtävä: "6 + 2 = ?",
			  oikea: 8,
			  väärät: [ 4,5,6,7,9 ],
			  suhde: 2 },
		    { tehtävä: "7 + 1 = ?",
			  oikea: 8,
			  väärät: [ 4,5,6,7,9 ],
			  suhde: 2 },
		    { tehtävä: "1 + 8 = ?",
			  oikea: 9,
			  väärät: [ 4,5,6,7,8 ],
			  suhde: 2 },			  		        	  	  	  
		    { tehtävä: "2 + 7 = ?",
			  oikea: 9,
			  väärät: [ 4,5,6,7,8 ],
			  suhde: 3 },	
		    { tehtävä: "3 + 6 = ?",
			  oikea: 9,
			  väärät: [ 4,5,6,7,8 ],
			  suhde: 3 },	
		    { tehtävä: "4 + 5 = ?",
			  oikea: 9,
			  väärät: [ 4,5,6,7,8 ],
			  suhde: 3 },	
		    { tehtävä: "5 + 4 = ?",
			  oikea: 9,
			  väärät: [ 4,5,6,7,8 ],
			  suhde: 3 },	
		    { tehtävä: "6 + 3 = ?",
			  oikea: 9,
			  väärät: [ 4,5,6,7,8 ],
			  suhde: 3 },	
		    { tehtävä: "7 + 2 = ?",
			  oikea: 9,
			  väärät: [ 4,5,6,7,8 ],
			  suhde: 3 },	
		    { tehtävä: "8 + 1 = ?",
			  oikea: 9,
			  väärät: [ 4,5,6,7,8 ],
			  suhde: 2 },		
		    { tehtävä: "1 + 9 = ?",
			  oikea: 10,
			  väärät: [ 5,6,7,8,9 ],
			  suhde: 2 },			  		        	  	  	  
		    { tehtävä: "2 + 8 = ?",
			  oikea: 10,
			  väärät: [ 5,6,7,8,9 ],
			  suhde: 2 },	
		    { tehtävä: "3 + 7 = ?",
			  oikea: 10,
			  väärät: [ 5,6,7,8,9 ],
			  suhde: 2 },	
		    { tehtävä: "4 + 6 = ?",
			  oikea: 10,
			  väärät: [ 5,6,7,8,9 ],
			  suhde: 2 },	
		    { tehtävä: "5 + 5 = ?",
			  oikea: 10,
			  väärät: [ 5,6,7,8,9 ],
			  suhde: 2 },	
		    { tehtävä: "6 + 4 = ?",
			  oikea: 10,
			  väärät: [ 5,6,7,8,9 ],
			  suhde: 2 },	
		    { tehtävä: "7 + 3 = ?",
			  oikea: 10,
			  väärät: [ 5,6,7,8,9 ],
			  suhde: 2 },	
		    { tehtävä: "8 + 2 = ?",
			  oikea: 10,
			  väärät: [ 5,6,7,8,9 ],
			  suhde: 2 },		
		    { tehtävä: "9 + 1 = ?",
			  oikea: 10,
			  väärät: [ 5,6,7,8,9 ],
			  suhde: 2 },			  
	  ]				  	  
	},
	kertolaskut: {
	 	"2": [
			{ tehtävä: "1 \u00D7 2 = ?",
				oikea: 2,
				väärät: [ 1, 3, 4, 5, 6 ],
				suhde: 4 },
			{ tehtävä: "2 \u00D7 2 = ?",
				oikea: 4,
				väärät: [ 2, 3, 5, 6, 8 ],
				suhde: 6 },
			{ tehtävä: "3 \u00D7 2 = ?",
				oikea: 6,
				väärät: [ 4, 5, 8, 9, 10 ],
				suhde: 10 },
			{ tehtävä: "4 \u00D7 2 = ?",
				oikea: 8,
				väärät: [ 4, 6, 9, 10, 12 ],
				suhde: 10 },
			{ tehtävä: "5 \u00D7 2 = ?",
				oikea: 10,
				väärät: [ 6, 8, 9, 12, 14],
				suhde: 6 },
			{ tehtävä: "6 \u00D7 2 = ?",
				oikea: 12,
				väärät: [ 8, 10, 14, 15, 16 ],
				suhde: 12 },
			{ tehtävä: "7 \u00D7 2 = ?",
				oikea: 14,
				väärät: [ 10, 12, 15, 16, 18 ],
				suhde: 16 },
			{ tehtävä: "8 \u00D7 2 = ?",
				oikea: 16,
				väärät: [ 12, 14, 15, 18, 20 ],
				suhde: 16 },
			{ tehtävä: "9 \u00D7 2 = ?",
				oikea: 18,
				väärät: [ 14, 16, 20, 21, 22 ],
				suhde: 16 },
			{ tehtävä: "10 \u00D7 2 = ?",
				oikea: 20,
				väärät: [ 16, 18, 22, 24, 30 ],
				suhde: 4 }
		],		
	 	"3": [
			{ tehtävä: "1 \u00D7 3 = ?",
				oikea: 3,
				väärät: [ 1, 2, 4, 5, 6 ],
				suhde: 4 },
			{ tehtävä: "2 \u00D7 3 = ?",
				oikea: 6,
				väärät: [ 2, 4, 5, 7, 8, 9 ],
				suhde: 6 },
			{ tehtävä: "3 \u00D7 3 = ?",
				oikea: 9,
				väärät: [ 6, 8, 10, 12, 14, 15 ],
				suhde: 10 },
			{ tehtävä: "4 \u00D7 3 = ?",
				oikea: 12,
				väärät: [ 6, 9, 10, 14, 15, 18 ],
				suhde: 10 },
			{ tehtävä: "5 \u00D7 3 = ?",
				oikea: 15,
				väärät: [ 10, 12, 14, 16, 18, 21],
				suhde: 6 },
			{ tehtävä: "6 \u00D7 3 = ?",
				oikea: 18,
				väärät: [ 12, 14, 16, 20, 21, 24 ],
				suhde: 12 },
			{ tehtävä: "7 \u00D7 3 = ?",
				oikea: 21,
				väärät: [ 16, 18, 20, 24, 25, 27 ],
				suhde: 16 },
			{ tehtävä: "8 \u00D7 3 = ?",
				oikea: 24,
				väärät: [ 18, 20, 22, 25, 27, 28, 30 ],
				suhde: 16 },
			{ tehtävä: "9 \u00D7 3 = ?",
				oikea: 27,
				väärät: [ 21, 24, 25, 29, 30, 32 ],
				suhde: 16 },
			{ tehtävä: "10 \u00D7 3 = ?",
				oikea: 30,
				väärät: [ 24, 27, 28, 32, 35, 36 ],
				suhde: 4 }
		],
		"4": [
			{ tehtävä: "1 \u00D7 4 = ?",
				oikea: 4,
				väärät: [ 1, 2, 3, 5, 6, 7 ],
				suhde: 4 },
			{ tehtävä: "2 \u00D7 4 = ?",
				oikea: 8,
				väärät: [ 2, 4, 6, 7, 9, 10, 12 ],
				suhde: 6 },
			{ tehtävä: "3 \u00D7 4 = ?",
				oikea: 12,
				väärät: [ 6, 8, 9, 10, 14, 15, 16 ],
				suhde: 10 },
			{ tehtävä: "4 \u00D7 4 = ?",
				oikea: 16,
				väärät: [ 10, 12, 15, 18, 20, 21 ],
				suhde: 10 },
			{ tehtävä: "5 \u00D7 4 = ?",
				oikea: 20,
				väärät: [ 15, 16, 18, 21, 24, 25 ],
				suhde: 6 },
			{ tehtävä: "6 \u00D7 4 = ?",
				oikea: 24,
				väärät: [ 18, 21, 25, 27, 28, 30 ],
				suhde: 12 },
			{ tehtävä: "7 \u00D7 4 = ?",
				oikea: 28,
				väärät: [ 24, 25, 27, 30, 32, 35, 36 ],
				suhde: 16 },
			{ tehtävä: "8 \u00D7 4 = ?",
				oikea: 32,
				väärät: [ 24, 27, 30, 35, 36, 40 ],
				suhde: 16 },
			{ tehtävä: "9 \u00D7 4 = ?",
				oikea: 36,
				väärät: [ 24, 27, 30, 35, 40, 42, 45 ],
				suhde: 16 },
			{ tehtävä: "10 \u00D7 4 = ?",
				oikea: 40,
				väärät: [ 30, 35, 36, 42, 45, 48, 50 ],
				suhde: 4 }
		],
		"5": [
			{ tehtävä: "1 \u00D7 5 = ?",
				oikea: 5,
				väärät: [ 1, 3, 4, 6, 7, 8 ],
				suhde: 4 },
			{ tehtävä: "2 \u00D7 5  = ?",
				oikea: 10,
				väärät: [ 5, 8, 12, 14, 15 ], 
				suhde: 6 },
			{ tehtävä: "3 \u00D7 5 = ?",
				oikea: 15,
				väärät: [ 10, 12, 14, 16, 18, 20 ],
				suhde: 10 },
			{ tehtävä: "4 \u00D7 5 = ?",
				oikea: 20,
				väärät: [ 10, 15, 18, 21, 24, 25 ],
				suhde: 10 },
			{ tehtävä: "5 \u00D7 5 = ?",
				oikea: 25,
				väärät: [ 15, 20, 21, 24, 27, 30 ],
				suhde: 6 },
			{ tehtävä: "6 \u00D7 5 = ?",
				oikea: 30,
				väärät: [ 24, 25, 27, 32, 35, 36 ],
				suhde: 12 },
			{ tehtävä: "7 \u00D7 5 = ?",
				oikea: 35,
				väärät: [ 28, 30, 32, 36, 40, 42 ],
				suhde: 16 },
			{ tehtävä: "8 \u00D7 5 = ?",
				oikea: 40,
				väärät: [ 32, 35, 36, 42, 45, 48 ],
				suhde: 16 },
			{ tehtävä: "9 \u00D7 5 = ?",
				oikea: 45,
				väärät: [ 36, 40, 42, 48, 50, 54 ],
				suhde: 16 },
			{ tehtävä: "10 \u00D7 5 = ?",
				oikea: 50,
				väärät: [ 40, 48, 54, 55, 60 ],
				suhde: 4 }
		],
		"6": [
			{ tehtävä: "1 \u00D7 6 = ?",
				oikea: 6,
				väärät: [ 3, 4, 5, 7, 8, 9 ],
				suhde: 4 },
			{ tehtävä: "2 \u00D7 6  = ?",
				oikea: 12,
				väärät: [ 9, 10, 14, 15, 18 ], 
				suhde: 6 },
			{ tehtävä: "3 \u00D7 6 = ?",
				oikea: 18,
				väärät: [ 12, 14, 16, 20, 24 ],
				suhde: 10 },
			{ tehtävä: "4 \u00D7 6 = ?",
				oikea: 24,
				väärät: [ 18, 21, 25, 29, 30 ],
				suhde: 10 },
			{ tehtävä: "5 \u00D7 6 = ?",
				oikea: 30,
				väärät: [ 24, 25, 27, 35, 36 ],
				suhde: 6 },
			{ tehtävä: "6 \u00D7 6 = ?",
				oikea: 36,
				väärät: [ 30, 32, 35, 40, 42 ],
				suhde: 12 },
			{ tehtävä: "7 \u00D7 6 = ?",
				oikea: 42,
				väärät: [ 36, 40, 45, 49 ],
				suhde: 16 },
			{ tehtävä: "8 \u00D7 6 = ?",
				oikea: 48,
				väärät: [ 42, 45, 49, 54, 56 ],
				suhde: 16 },
			{ tehtävä: "9 \u00D7 6 = ?",
				oikea: 54,
				väärät: [ 45, 48, 49, 50, 63 ],
				suhde: 16 },
			{ tehtävä: "10 \u00D7 6 = ?",
				oikea: 60,
				väärät: [ 50, 54, 63, 66, 70 ],
				suhde: 4 }
		],
"7": [
			{ tehtävä: "1 \u00D7 7 = ?",
				oikea: 7,
				väärät: [ 3, 4, 5, 6, 8, 9 ],
				suhde: 4 },
			{ tehtävä: "2 \u00D7 7  = ?",
				oikea: 14,
				väärät: [ 7, 12, 15, 18, 21 ], 
				suhde: 6 },
			{ tehtävä: "3 \u00D7 7 = ?",
				oikea: 21,
				väärät: [ 14, 16, 20, 24, 28 ],
				suhde: 10 },
			{ tehtävä: "4 \u00D7 7 = ?",
				oikea: 28,
				väärät: [ 21, 24, 29, 32, 35 ],
				suhde: 10 },
			{ tehtävä: "5 \u00D7 7 = ?",
				oikea: 35,
				väärät: [ 28, 30, 32, 40, 42 ],
				suhde: 6 },
			{ tehtävä: "6 \u00D7 7 = ?",
				oikea: 42,
				väärät: [ 35, 40, 45, 48, 49 ],
				suhde: 12 },
			{ tehtävä: "7 \u00D7 7 = ?",
				oikea: 49,
				väärät: [ 42, 45, 48, 54, 56 ],
				suhde: 16 },
			{ tehtävä: "8 \u00D7 7 = ?",
				oikea: 56,
				väärät: [ 49, 54, 55, 60, 63 ],
				suhde: 16 },
			{ tehtävä: "9 \u00D7 7 = ?",
				oikea: 63,
				väärät: [ 49, 50, 55, 64, 70 ],
				suhde: 16 },
			{ tehtävä: "10 \u00D7 7 = ?",
				oikea: 70,
				väärät: [ 60, 63, 63, 72, 80 ],
				suhde: 4 }
		],
"8": [
			{ tehtävä: "1 \u00D7 8 = ?",
				oikea: 8,
				väärät: [ 3, 4, 5, 6, 7, 9 ],
				suhde: 4 },
			{ tehtävä: "2 \u00D7 8  = ?",
				oikea: 16,
				väärät: [ 8, 12, 15, 18, 24 ], 
				suhde: 6 },
			{ tehtävä: "3 \u00D7 8 = ?",
				oikea: 24,
				väärät: [ 12, 16, 21, 27, 32 ],
				suhde: 10 },
			{ tehtävä: "4 \u00D7 8 = ?",
				oikea: 32,
				väärät: [ 24, 28, 35, 36, 40 ],
				suhde: 10 },
			{ tehtävä: "5 \u00D7 8 = ?",
				oikea: 40,
				väärät: [ 32, 35, 42, 45, 48 ],
				suhde: 6 },
			{ tehtävä: "6 \u00D7 8 = ?",
				oikea: 48,
				väärät: [ 40, 42, 45, 49, 56 ],
				suhde: 12 },
			{ tehtävä: "7 \u00D7 8 = ?",
				oikea: 56,
				väärät: [ 48, 49, 54, 63, 64 ],
				suhde: 16 },
			{ tehtävä: "8 \u00D7 8 = ?",
				oikea: 64,
				väärät: [ 56, 63, 68, 72 ],
				suhde: 16 },
			{ tehtävä: "9 \u00D7 8 = ?",
				oikea: 72,
				väärät: [ 64, 68, 74, 81 ],
				suhde: 16 },
			{ tehtävä: "10 \u00D7 8 = ?",
				oikea: 80,
				väärät: [ 72, 74, 81, 88 ],
				suhde: 4 }
		],	
"9": [
			{ tehtävä: "1 \u00D7 9 = ?",
				oikea: 9,
				väärät: [ 3, 4, 5, 6, 7, 8 ],
				suhde: 4 },
			{ tehtävä: "2 \u00D7 9  = ?",
				oikea: 18,
				väärät: [ 9, 16, 24, 27 ], 
				suhde: 6 },
			{ tehtävä: "3 \u00D7 9 = ?",
				oikea: 27,
				väärät: [ 18, 24, 32, 36 ],
				suhde: 10 },
			{ tehtävä: "4 \u00D7 9 = ?",
				oikea: 36,
				väärät: [ 27, 32, 42, 45 ],
				suhde: 10 },
			{ tehtävä: "5 \u00D7 9 = ?",
				oikea: 45,
				väärät: [ 36, 42, 48, 54 ],
				suhde: 6 },
			{ tehtävä: "6 \u00D7 9 = ?",
				oikea: 54,
				väärät: [ 45, 48, 56, 63 ],
				suhde: 12 },
			{ tehtävä: "7 \u00D7 9 = ?",
				oikea: 63,
				väärät: [ 54, 56, 64, 72 ],
				suhde: 16 },
			{ tehtävä: "8 \u00D7 9 = ?",
				oikea: 72,
				väärät: [ 63, 64, 68, 81 ],
				suhde: 16 },
			{ tehtävä: "9 \u00D7 9 = ?",
				oikea: 81,
				väärät: [ 72, 74, 84, 90 ],
				suhde: 16 },
			{ tehtävä: "10 \u00D7 9 = ?",
				oikea: 90,
				väärät: [ 81, 84, 91, 99 ],
				suhde: 4 }
		],				
"10": [
			{ tehtävä: "1 \u00D7 10 = ?",
				oikea: 10,
				väärät: [ 8, 9, 12, 15, 20 ],
				suhde: 4 },
			{ tehtävä: "2 \u00D7 10  = ?",
				oikea: 20,
				väärät: [ 10, 18, 21, 25, 30 ], 
				suhde: 6 },
			{ tehtävä: "3 \u00D7 10 = ?",
				oikea: 30,
				väärät: [ 20, 25, 29, 35, 40 ],
				suhde: 10 },
			{ tehtävä: "4 \u00D7 10 = ?",
				oikea: 40,
				väärät: [ 30, 35, 36, 45, 50 ],
				suhde: 10 },
			{ tehtävä: "5 \u00D7 10 = ?",
				oikea: 50,
				väärät: [ 40, 45, 49, 55, 60 ],
				suhde: 6 },
			{ tehtävä: "6 \u00D7 10 = ?",
				oikea: 60,
				väärät: [ 50, 55, 63, 65, 70 ],
				suhde: 12 },
			{ tehtävä: "7 \u00D7 10 = ?",
				oikea: 70,
				väärät: [ 60, 65, 72, 75, 80 ],
				suhde: 16 },
			{ tehtävä: "8 \u00D7 10 = ?",
				oikea: 80,
				väärät: [ 70, 75, 81, 85, 90 ],
				suhde: 16 },
			{ tehtävä: "9 \u00D7 10 = ?",
				oikea: 90,
				väärät: [ 80, 81, 85, 95, 100 ],
				suhde: 16 },
			{ tehtävä: "10 \u00D7 10 = ?",
				oikea: 100,
				väärät: [ 90, 95, 105, 110 ],
				suhde: 4 }
		],
"100": [
			{ tehtävä: "1 \u00D7 2 = ?",
				oikea: 2,
				väärät: [ 1, 3, 4, 5, 6 ],
				suhde: 1 },
			{ tehtävä: "2 \u00D7 2 = ?",
				oikea: 4,
				väärät: [ 2, 3, 5, 6, 8 ],
				suhde: 1 },
			{ tehtävä: "3 \u00D7 2 = ?",
				oikea: 6,
				väärät: [ 4, 5, 8, 9, 10 ],
				suhde: 1 },
			{ tehtävä: "4 \u00D7 2 = ?",
				oikea: 8,
				väärät: [ 4, 6, 9, 10, 12 ],
				suhde: 1 },
			{ tehtävä: "5 \u00D7 2 = ?",
				oikea: 10,
				väärät: [ 6, 8, 9, 12, 14],
				suhde: 1 },
			{ tehtävä: "6 \u00D7 2 = ?",
				oikea: 12,
				väärät: [ 8, 10, 14, 15, 16 ],
				suhde: 1 },
			{ tehtävä: "7 \u00D7 2 = ?",
				oikea: 14,
				väärät: [ 10, 12, 15, 16, 18 ],
				suhde: 1 },
			{ tehtävä: "8 \u00D7 2 = ?",
				oikea: 16,
				väärät: [ 12, 14, 15, 18, 20 ],
				suhde: 1 },
			{ tehtävä: "9 \u00D7 2 = ?",
				oikea: 18,
				väärät: [ 14, 16, 20, 21, 22 ],
				suhde: 1 },
			{ tehtävä: "10 \u00D7 2 = ?",
				oikea: 20,
				väärät: [ 16, 18, 22, 24, 30 ],
				suhde: 1 },
			{ tehtävä: "1 \u00D7 3 = ?",
				oikea: 3,
				väärät: [ 1, 2, 4, 5, 6 ],
				suhde: 1 },
			{ tehtävä: "2 \u00D7 3 = ?",
				oikea: 6,
				väärät: [ 2, 4, 5, 7, 8, 9 ],
				suhde: 1 },
			{ tehtävä: "3 \u00D7 3 = ?",
				oikea: 9,
				väärät: [ 6, 8, 10, 12, 14, 15 ],
				suhde: 1 },
			{ tehtävä: "4 \u00D7 3 = ?",
				oikea: 12,
				väärät: [ 6, 9, 10, 14, 15, 18 ],
				suhde: 1 },
			{ tehtävä: "5 \u00D7 3 = ?",
				oikea: 15,
				väärät: [ 10, 12, 14, 16, 18, 21],
				suhde: 1 },
			{ tehtävä: "6 \u00D7 3 = ?",
				oikea: 18,
				väärät: [ 12, 14, 16, 20, 21, 24 ],
				suhde: 1 },
			{ tehtävä: "7 \u00D7 3 = ?",
				oikea: 21,
				väärät: [ 16, 18, 20, 24, 25, 27 ],
				suhde: 1 },
			{ tehtävä: "8 \u00D7 3 = ?",
				oikea: 24,
				väärät: [ 18, 20, 22, 25, 27, 28, 30 ],
				suhde: 1 },
			{ tehtävä: "9 \u00D7 3 = ?",
				oikea: 27,
				väärät: [ 21, 24, 25, 29, 30, 32 ],
				suhde: 1 },
			{ tehtävä: "10 \u00D7 3 = ?",
				oikea: 30,
				väärät: [ 24, 27, 28, 32, 35, 36 ],
				suhde: 1 },
			{ tehtävä: "1 \u00D7 4 = ?",
				oikea: 4,
				väärät: [ 1, 2, 3, 5, 6, 7 ],
				suhde: 1 },
			{ tehtävä: "2 \u00D7 4 = ?",
				oikea: 8,
				väärät: [ 2, 4, 6, 7, 9, 10, 12 ],
				suhde: 1 },
			{ tehtävä: "3 \u00D7 4 = ?",
				oikea: 12,
				väärät: [ 6, 8, 9, 10, 14, 15, 16 ],
				suhde: 1 },
			{ tehtävä: "4 \u00D7 4 = ?",
				oikea: 16,
				väärät: [ 10, 12, 15, 18, 20, 21 ],
				suhde: 1 },
			{ tehtävä: "5 \u00D7 4 = ?",
				oikea: 20,
				väärät: [ 15, 16, 18, 21, 24, 25 ],
				suhde: 1 },
			{ tehtävä: "6 \u00D7 4 = ?",
				oikea: 24,
				väärät: [ 18, 21, 25, 27, 28, 30 ],
				suhde: 1 },
			{ tehtävä: "7 \u00D7 4 = ?",
				oikea: 28,
				väärät: [ 24, 25, 27, 30, 32, 35, 36 ],
				suhde: 1 },
			{ tehtävä: "8 \u00D7 4 = ?",
				oikea: 32,
				väärät: [ 24, 27, 30, 35, 36, 40 ],
				suhde: 1 },
			{ tehtävä: "9 \u00D7 4 = ?",
				oikea: 36,
				väärät: [ 24, 27, 30, 35, 40, 42, 45 ],
				suhde: 1 },
			{ tehtävä: "10 \u00D7 4 = ?",
				oikea: 40,
				väärät: [ 30, 35, 36, 42, 45, 48, 50 ],
				suhde: 1 },
			{ tehtävä: "1 \u00D7 5 = ?",
				oikea: 5,
				väärät: [ 1, 3, 4, 6, 7, 8 ],
				suhde: 1 },
			{ tehtävä: "2 \u00D7 5  = ?",
				oikea: 10,
				väärät: [ 5, 8, 12, 14, 15 ], 
				suhde: 1 },
			{ tehtävä: "3 \u00D7 5 = ?",
				oikea: 15,
				väärät: [ 10, 12, 14, 16, 18, 20 ],
				suhde: 1 },
			{ tehtävä: "4 \u00D7 5 = ?",
				oikea: 20,
				väärät: [ 10, 15, 18, 21, 24, 25 ],
				suhde: 1 },
			{ tehtävä: "5 \u00D7 5 = ?",
				oikea: 25,
				väärät: [ 15, 20, 21, 24, 27, 30 ],
				suhde: 1 },
			{ tehtävä: "6 \u00D7 5 = ?",
				oikea: 30,
				väärät: [ 24, 25, 27, 32, 35, 36 ],
				suhde: 1 },
			{ tehtävä: "7 \u00D7 5 = ?",
				oikea: 35,
				väärät: [ 28, 30, 32, 36, 40, 42 ],
				suhde: 1 },
			{ tehtävä: "8 \u00D7 5 = ?",
				oikea: 40,
				väärät: [ 32, 35, 36, 42, 45, 48 ],
				suhde: 1 },
			{ tehtävä: "9 \u00D7 5 = ?",
				oikea: 45,
				väärät: [ 36, 40, 42, 48, 50, 54 ],
				suhde: 1 },
			{ tehtävä: "10 \u00D7 5 = ?",
				oikea: 50,
				väärät: [ 40, 48, 54, 55, 60 ],
				suhde: 1 },
			{ tehtävä: "1 \u00D7 6 = ?",
				oikea: 6,
				väärät: [ 3, 4, 5, 7, 8, 9 ],
				suhde: 1 },
			{ tehtävä: "2 \u00D7 6  = ?",
				oikea: 12,
				väärät: [ 9, 10, 14, 15, 18 ], 
				suhde: 1 },
			{ tehtävä: "3 \u00D7 6 = ?",
				oikea: 18,
				väärät: [ 12, 14, 16, 20, 24 ],
				suhde: 2 },
			{ tehtävä: "4 \u00D7 6 = ?",
				oikea: 24,
				väärät: [ 18, 21, 25, 29, 30 ],
				suhde: 1 },
			{ tehtävä: "5 \u00D7 6 = ?",
				oikea: 30,
				väärät: [ 24, 25, 27, 35, 36 ],
				suhde: 1 },
			{ tehtävä: "6 \u00D7 6 = ?",
				oikea: 36,
				väärät: [ 30, 32, 35, 40, 42 ],
				suhde: 1 },
			{ tehtävä: "7 \u00D7 6 = ?",
				oikea: 42,
				väärät: [ 36, 40, 45, 49 ],
				suhde: 1 },
			{ tehtävä: "8 \u00D7 6 = ?",
				oikea: 48,
				väärät: [ 42, 45, 49, 54, 56 ],
				suhde: 2 },
			{ tehtävä: "9 \u00D7 6 = ?",
				oikea: 54,
				väärät: [ 45, 48, 49, 50, 63 ],
				suhde: 1 },
			{ tehtävä: "10 \u00D7 6 = ?",
				oikea: 60,
				väärät: [ 50, 54, 63, 66, 70 ],
				suhde: 1 },
			{ tehtävä: "1 \u00D7 7 = ?",
				oikea: 7,
				väärät: [ 3, 4, 5, 6, 8, 9 ],
				suhde: 1 },
			{ tehtävä: "2 \u00D7 7  = ?",
				oikea: 14,
				väärät: [ 7, 12, 15, 18, 21 ], 
				suhde: 1 },
			{ tehtävä: "3 \u00D7 7 = ?",
				oikea: 21,
				väärät: [ 14, 16, 20, 24, 28 ],
				suhde: 2 },
			{ tehtävä: "4 \u00D7 7 = ?",
				oikea: 28,
				väärät: [ 21, 24, 29, 32, 35 ],
				suhde: 2 },
			{ tehtävä: "5 \u00D7 7 = ?",
				oikea: 35,
				väärät: [ 28, 30, 32, 40, 42 ],
				suhde: 1 },
			{ tehtävä: "6 \u00D7 7 = ?",
				oikea: 42,
				väärät: [ 35, 40, 45, 48, 49 ],
				suhde: 2 },
			{ tehtävä: "7 \u00D7 7 = ?",
				oikea: 49,
				väärät: [ 42, 45, 48, 54, 56 ],
				suhde: 2 },
			{ tehtävä: "8 \u00D7 7 = ?",
				oikea: 56,
				väärät: [ 49, 54, 55, 60, 63 ],
				suhde: 2 },
			{ tehtävä: "9 \u00D7 7 = ?",
				oikea: 63,
				väärät: [ 49, 50, 55, 64, 70 ],
				suhde: 2 },
			{ tehtävä: "10 \u00D7 7 = ?",
				oikea: 70,
				väärät: [ 60, 63, 63, 72, 80 ],
				suhde: 1 },
			{ tehtävä: "1 \u00D7 8 = ?",
				oikea: 8,
				väärät: [ 3, 4, 5, 6, 7, 9 ],
				suhde: 1 },
			{ tehtävä: "2 \u00D7 8  = ?",
				oikea: 16,
				väärät: [ 8, 12, 15, 18, 24 ], 
				suhde: 1 },
			{ tehtävä: "3 \u00D7 8 = ?",
				oikea: 24,
				väärät: [ 12, 16, 21, 27, 32 ],
				suhde: 2 },
			{ tehtävä: "4 \u00D7 8 = ?",
				oikea: 32,
				väärät: [ 24, 28, 35, 36, 40 ],
				suhde: 1 },
			{ tehtävä: "5 \u00D7 8 = ?",
				oikea: 40,
				väärät: [ 32, 35, 42, 45, 48 ],
				suhde: 1 },
			{ tehtävä: "6 \u00D7 8 = ?",
				oikea: 48,
				väärät: [ 40, 42, 45, 49, 56 ],
				suhde: 1 },
			{ tehtävä: "7 \u00D7 8 = ?",
				oikea: 56,
				väärät: [ 48, 49, 54, 63, 64 ],
				suhde: 1 },
			{ tehtävä: "8 \u00D7 8 = ?",
				oikea: 64,
				väärät: [ 56, 63, 68, 72 ],
				suhde: 2 },
			{ tehtävä: "9 \u00D7 8 = ?",
				oikea: 72,
				väärät: [ 64, 68, 74, 81 ],
				suhde: 1 },
			{ tehtävä: "10 \u00D7 8 = ?",
				oikea: 80,
				väärät: [ 72, 74, 81, 88 ],
				suhde: 1 },
			{ tehtävä: "1 \u00D7 9 = ?",
				oikea: 9,
				väärät: [ 3, 4, 5, 6, 7, 8 ],
				suhde: 1 },
			{ tehtävä: "2 \u00D7 9  = ?",
				oikea: 18,
				väärät: [ 9, 16, 24, 27 ], 
				suhde: 1 },
			{ tehtävä: "3 \u00D7 9 = ?",
				oikea: 27,
				väärät: [ 18, 24, 32, 36 ],
				suhde: 1 },
			{ tehtävä: "4 \u00D7 9 = ?",
				oikea: 36,
				väärät: [ 27, 32, 42, 45 ],
				suhde: 1 },
			{ tehtävä: "5 \u00D7 9 = ?",
				oikea: 45,
				väärät: [ 36, 42, 48, 54 ],
				suhde: 1 },
			{ tehtävä: "6 \u00D7 9 = ?",
				oikea: 54,
				väärät: [ 45, 48, 56, 63 ],
				suhde: 1 },
			{ tehtävä: "7 \u00D7 9 = ?",
				oikea: 63,
				väärät: [ 54, 56, 64, 72 ],
				suhde: 1 },
			{ tehtävä: "8 \u00D7 9 = ?",
				oikea: 72,
				väärät: [ 63, 64, 68, 81 ],
				suhde: 1 },
			{ tehtävä: "9 \u00D7 9 = ?",
				oikea: 81,
				väärät: [ 72, 74, 84, 90 ],
				suhde: 1 },
			{ tehtävä: "10 \u00D7 9 = ?",
				oikea: 90,
				väärät: [ 81, 84, 91, 99 ],
				suhde: 1 },
			{ tehtävä: "1 \u00D7 10 = ?",
				oikea: 10,
				väärät: [ 8, 9, 12, 15, 20 ],
				suhde: 1 },
			{ tehtävä: "2 \u00D7 10  = ?",
				oikea: 20,
				väärät: [ 10, 18, 21, 25, 30 ], 
				suhde: 1 },
			{ tehtävä: "3 \u00D7 10 = ?",
				oikea: 30,
				väärät: [ 20, 25, 29, 35, 40 ],
				suhde: 1 },
			{ tehtävä: "4 \u00D7 10 = ?",
				oikea: 40,
				väärät: [ 30, 35, 36, 45, 50 ],
				suhde: 1 },
			{ tehtävä: "5 \u00D7 10 = ?",
				oikea: 50,
				väärät: [ 40, 45, 49, 55, 60 ],
				suhde: 1 },
			{ tehtävä: "6 \u00D7 10 = ?",
				oikea: 60,
				väärät: [ 50, 55, 63, 65, 70 ],
				suhde: 1 },
			{ tehtävä: "7 \u00D7 10 = ?",
				oikea: 70,
				väärät: [ 60, 65, 72, 75, 80 ],
				suhde: 1 },
			{ tehtävä: "8 \u00D7 10 = ?",
				oikea: 80,
				väärät: [ 70, 75, 81, 85, 90 ],
				suhde: 1 },
			{ tehtävä: "9 \u00D7 10 = ?",
				oikea: 90,
				väärät: [ 80, 81, 85, 95, 100 ],
				suhde: 1 },
			{ tehtävä: "10 \u00D7 10 = ?",
				oikea: 100,
				väärät: [ 90, 95, 105, 110 ],
				suhde: 1 }
		],
		"50": [
			{ tehtävä: "1 \u00D7 2 = ?",
				oikea: 2,
				väärät: [ 1, 3, 4, 5, 6 ],
				suhde: 1 },
			{ tehtävä: "2 \u00D7 2 = ?",
				oikea: 4,
				väärät: [ 2, 3, 5, 6, 8 ],
				suhde: 2 },
			{ tehtävä: "3 \u00D7 2 = ?",
				oikea: 6,
				väärät: [ 4, 5, 8, 9, 10 ],
				suhde: 2 },
			{ tehtävä: "4 \u00D7 2 = ?",
				oikea: 8,
				väärät: [ 4, 6, 9, 10, 12 ],
				suhde: 2 },
			{ tehtävä: "5 \u00D7 2 = ?",
				oikea: 10,
				väärät: [ 6, 8, 9, 12, 14],
				suhde: 2 },
			{ tehtävä: "6 \u00D7 2 = ?",
				oikea: 12,
				väärät: [ 8, 10, 14, 15, 16 ],
				suhde: 2 },
			{ tehtävä: "7 \u00D7 2 = ?",
				oikea: 14,
				väärät: [ 10, 12, 15, 16, 18 ],
				suhde: 2 },
			{ tehtävä: "8 \u00D7 2 = ?",
				oikea: 16,
				väärät: [ 12, 14, 15, 18, 20 ],
				suhde: 2 },
			{ tehtävä: "9 \u00D7 2 = ?",
				oikea: 18,
				väärät: [ 14, 16, 20, 21, 22 ],
				suhde: 2 },
			{ tehtävä: "10 \u00D7 2 = ?",
				oikea: 20,
				väärät: [ 16, 18, 22, 24, 30 ],
				suhde: 1 },
			{ tehtävä: "1 \u00D7 3 = ?",
				oikea: 3,
				väärät: [ 1, 2, 4, 5, 6 ],
				suhde: 1 },
			{ tehtävä: "2 \u00D7 3 = ?",
				oikea: 6,
				väärät: [ 2, 4, 5, 7, 8, 9 ],
				suhde: 2 },
			{ tehtävä: "3 \u00D7 3 = ?",
				oikea: 9,
				väärät: [ 6, 8, 10, 12, 14, 15 ],
				suhde: 3 },
			{ tehtävä: "4 \u00D7 3 = ?",
				oikea: 12,
				väärät: [ 6, 9, 10, 14, 15, 18 ],
				suhde: 3 },
			{ tehtävä: "5 \u00D7 3 = ?",
				oikea: 15,
				väärät: [ 10, 12, 14, 16, 18, 21],
				suhde: 3 },
			{ tehtävä: "6 \u00D7 3 = ?",
				oikea: 18,
				väärät: [ 12, 14, 16, 20, 21, 24 ],
				suhde: 3 },
			{ tehtävä: "7 \u00D7 3 = ?",
				oikea: 21,
				väärät: [ 16, 18, 20, 24, 25, 27 ],
				suhde: 3 },
			{ tehtävä: "8 \u00D7 3 = ?",
				oikea: 24,
				väärät: [ 18, 20, 22, 25, 27, 28, 30 ],
				suhde: 3 },
			{ tehtävä: "9 \u00D7 3 = ?",
				oikea: 27,
				väärät: [ 21, 24, 25, 29, 30, 32 ],
				suhde: 3 },
			{ tehtävä: "10 \u00D7 3 = ?",
				oikea: 30,
				väärät: [ 24, 27, 28, 32, 35, 36 ],
				suhde: 1 },
			{ tehtävä: "1 \u00D7 4 = ?",
				oikea: 4,
				väärät: [ 1, 2, 3, 5, 6, 7 ],
				suhde: 1 },
			{ tehtävä: "2 \u00D7 4 = ?",
				oikea: 8,
				väärät: [ 2, 4, 6, 7, 9, 10, 12 ],
				suhde: 2 },
			{ tehtävä: "3 \u00D7 4 = ?",
				oikea: 12,
				väärät: [ 6, 8, 9, 10, 14, 15, 16 ],
				suhde: 3 },
			{ tehtävä: "4 \u00D7 4 = ?",
				oikea: 16,
				väärät: [ 10, 12, 15, 18, 20, 21 ],
				suhde: 3 },
			{ tehtävä: "5 \u00D7 4 = ?",
				oikea: 20,
				väärät: [ 15, 16, 18, 21, 24, 25 ],
				suhde: 3 },
			{ tehtävä: "6 \u00D7 4 = ?",
				oikea: 24,
				väärät: [ 18, 21, 25, 27, 28, 30 ],
				suhde: 3 },
			{ tehtävä: "7 \u00D7 4 = ?",
				oikea: 28,
				väärät: [ 24, 25, 27, 30, 32, 35, 36 ],
				suhde: 3 },
			{ tehtävä: "8 \u00D7 4 = ?",
				oikea: 32,
				väärät: [ 24, 27, 30, 35, 36, 40 ],
				suhde: 3 },
			{ tehtävä: "9 \u00D7 4 = ?",
				oikea: 36,
				väärät: [ 24, 27, 30, 35, 40, 42, 45 ],
				suhde: 3 },
			{ tehtävä: "10 \u00D7 4 = ?",
				oikea: 40,
				väärät: [ 30, 35, 36, 42, 45, 48, 50 ],
				suhde: 1 },
			{ tehtävä: "1 \u00D7 5 = ?",
				oikea: 5,
				väärät: [ 1, 3, 4, 6, 7, 8 ],
				suhde: 1 },
			{ tehtävä: "2 \u00D7 5  = ?",
				oikea: 10,
				väärät: [ 5, 8, 12, 14, 15 ], 
				suhde: 2 },
			{ tehtävä: "3 \u00D7 5 = ?",
				oikea: 15,
				väärät: [ 10, 12, 14, 16, 18, 20 ],
				suhde: 2 },
			{ tehtävä: "4 \u00D7 5 = ?",
				oikea: 20,
				väärät: [ 10, 15, 18, 21, 24, 25 ],
				suhde: 2 },
			{ tehtävä: "5 \u00D7 5 = ?",
				oikea: 25,
				väärät: [ 15, 20, 21, 24, 27, 30 ],
				suhde: 2 },
			{ tehtävä: "6 \u00D7 5 = ?",
				oikea: 30,
				väärät: [ 24, 25, 27, 32, 35, 36 ],
				suhde: 3 },
			{ tehtävä: "7 \u00D7 5 = ?",
				oikea: 35,
				väärät: [ 28, 30, 32, 36, 40, 42 ],
				suhde: 3 },
			{ tehtävä: "8 \u00D7 5 = ?",
				oikea: 40,
				väärät: [ 32, 35, 36, 42, 45, 48 ],
				suhde: 3 },
			{ tehtävä: "9 \u00D7 5 = ?",
				oikea: 45,
				väärät: [ 36, 40, 42, 48, 50, 54 ],
				suhde: 3 },
			{ tehtävä: "10 \u00D7 5 = ?",
				oikea: 50,
				väärät: [ 40, 48, 54, 55, 60 ],
				suhde: 1 },
			{ tehtävä: "1 \u00D7 10 = ?",
				oikea: 10,
				väärät: [ 8, 9, 12, 15, 20 ],
				suhde: 1 },
			{ tehtävä: "2 \u00D7 10  = ?",
				oikea: 20,
				väärät: [ 10, 18, 21, 25, 30 ], 
				suhde: 1 },
			{ tehtävä: "3 \u00D7 10 = ?",
				oikea: 30,
				väärät: [ 20, 25, 29, 35, 40 ],
				suhde: 1 },
			{ tehtävä: "4 \u00D7 10 = ?",
				oikea: 40,
				väärät: [ 30, 35, 36, 45, 50 ],
				suhde: 1 },
			{ tehtävä: "5 \u00D7 10 = ?",
				oikea: 50,
				väärät: [ 40, 45, 49, 55, 60 ],
				suhde: 1 },
			{ tehtävä: "6 \u00D7 10 = ?",
				oikea: 60,
				väärät: [ 50, 55, 63, 65, 70 ],
				suhde: 1 },
			{ tehtävä: "7 \u00D7 10 = ?",
				oikea: 70,
				väärät: [ 60, 65, 72, 75, 80 ],
				suhde: 1 },
			{ tehtävä: "8 \u00D7 10 = ?",
				oikea: 80,
				väärät: [ 70, 75, 81, 85, 90 ],
				suhde: 1 },
			{ tehtävä: "9 \u00D7 10 = ?",
				oikea: 90,
				väärät: [ 80, 81, 85, 95, 100 ],
				suhde: 1 },
			{ tehtävä: "10 \u00D7 10 = ?",
				oikea: 100,
				väärät: [ 90, 95, 105, 110 ],
				suhde: 1 }
		]				
	}
}

export default laskutehtävät 


// WEBPACK FOOTER //
// ./src/laskutehtävät.js